export default {
  JOB_ID: 'jobID',
  JOB_CITY_WORK_LOCATION_ID: 'jobCityWorkLocationID',
  MITRA_ID: 'mitraID',
  UTM_SOURCE: 'utm_source',
  SHOW_NEW_LANDING_PAGE: 'lp',
  OB2: 'ob2',
  FAD: 'fad',
  LLP: 'llp',
};
